/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Lot_LabelInputs */

const vi_confirm_return_lot_label = /** @type {(inputs: Confirm_Return_Lot_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô:`)
};

/**

* @param {Confirm_Return_Lot_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_lot_label = /** @type {((inputs?: Confirm_Return_Lot_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Lot_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_lot_label(inputs)
});